<template>
  <div :class="qaClass('panel', index)" class="c-panel u-mrgn-top--4 u-fg--black">
    <div class="c-panel__body">
      <div class="o-layout">
        <div class="o-layout__item u-5of12 u-pad-right--2 u-clearfix">
          <div class="u-float-left u-width-1of4">
            <a :href="miUrl" data-no-turbolink="true">
              <img :src="product.logo_url" style="width:70px;height:70px;" />
            </a>
          </div>
          <div class="u-float-left u-width-3of4 u-pad-left--3">
            <div class="u-txt--small u-mrgn-bottom--1">
              <a :href="typeUrl" :class="qaClass('type', index)" data-no-turbolink="true" class="u-fg--black"
                >Reksa Dana {{ product.type }}
              </a>
              <span
                v-if="product.promo_active"
                :class="['qa-br-promo-product-' + product.id]"
                class="c-label c-label--pink u-mrgn-left--1"
              >
                Promo
              </span>
            </div>
            <div class="u-mrgn-bottom--1">
              <a
                :href="productUrl"
                :class="qaClass('name', index)"
                data-no-turbolink="true"
                class="u-txt--medium u-txt--bold u-fg--black"
                >{{ product.name }}
              </a>
            </div>
          </div>
        </div>
        <div class="o-layout__item u-4of12 u-push-1of12 u-pad-left--2">
          <div :class="qaClass('nav-date', index)" class="u-width-1 u-txt--base">NAB/Unit ({{ navDate }})</div>
          <div class="u-width-1 u-pad-top--1">
            <span :class="qaClass('nav-value', index)" class="u-txt--medium u-txt--bold"> {{ navPrice }} </span>
          </div>
          <div class="u-width-1 u-pad-top--1 u-txt--base">
            <rod-value :return-value="product.return_one_day" :class="qaClass('return', index)" is-desktop />
          </div>
        </div>
        <div class="o-layout__item u-2of12 u-push-1of12 u-align-right">
          <bl-button-av :class="qaClass('buy-button', index)" block size="small" color="red" @click="goToBuyPage">
            Beli
          </bl-button-av>

          <bl-button-av
            :class="qaClass('chart-toggle', index)"
            class="u-mrgn-top--2"
            block
            size="small"
            @click="toggleChart"
          >
            <span class="c-btn__text">{{ chartButtonCta }}</span>
            <i :class="chartButtonIcon" class="c-btn__icon c-icon" />
          </bl-button-av>
        </div>
      </div>
      <product-chart
        v-if="showChart"
        :product="product"
        :show-upper-right-range-selector="true"
        :is-product-content="true"
      />
    </div>
  </div>
</template>
<script>
import BlButtonAv from '@bukalapak/bazaar-dweb/dist/components/BlButtonAv';
import RodValue from 'shared/components/RodValue';
import ProductChart from 'shared/components/ProductChart';
import dayjs from 'dayjs';
import { money } from 'shared/helpers/numberHelper';
import { generateSeoTypeUrl, generateSeoProductUrl, generateSeoInvestmentManagerUrl } from 'shared/helpers/seoMap';

export default {
  name: 'ProductItem',
  components: { RodValue, ProductChart, BlButtonAv },
  props: {
    product: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      default: 0,
    },
    fromSeoContent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showChart: false,
    };
  },
  computed: {
    navDate() {
      return dayjs(this.product.last_nav_updated_at).format('DD MMMM YYYY');
    },
    navPrice() {
      return money(this.product.last_nav_value);
    },
    chartButtonCta() {
      if (this.showChart) {
        return 'Tutup Grafik';
      }
      return 'Lihat Grafik';
    },
    chartButtonIcon() {
      if (this.showChart) {
        return 'c-icon--chevron-up';
      }
      return 'c-icon--chevron-down';
    },
    typeUrl() {
      return generateSeoTypeUrl(this.product.type);
    },
    miUrl() {
      return generateSeoInvestmentManagerUrl(this.product.im_code);
    },
    productUrl() {
      return generateSeoProductUrl(this.product.isin_code);
    },
  },
  methods: {
    toggleChart() {
      this.showChart = !this.showChart;
    },
    qaClass(object, idx) {
      return `qa-br-product-${object}-${idx + 1}`;
    },
    goToBuyPage() {
      if (this.fromSeoContent) {
        window.location.href = `/bukareksa/subscription/${this.product.isin_code}`;
      } else {
        this.$router.push({
          name: 'SubscriptionPage',
          params: {
            isin: this.product.isin_code,
          },
          query: {
            from: 'bukareksa_products_tab',
          },
        });
      }
    },
  },
};
</script>
